// extracted by css-extract-rspack-plugin
export default {"labelContainer":"labels-module__labelContainer__j6wBUZi","labelLink":"labels-module__labelLink__S2khmff"};